export class FileUploadModel {
	file?: File;
	referenceId: number;
	ApplicationId:number;
	UserId:number;
	createdBy?: number;
	updatedBy?: number;
	tempFolderName: string;
	filePath?: string;
	tempFileName: string;
	fileName?: string;
	fileType?: string;
	originalFileName?: string;
  }
  